import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const RelatedLinks = ({ items }) => (
  <div data-testid="related-links" className="flex flex-wrap gap-4">
    {items.map((item) => (
      <Link
        key={item.to}
        to={item.to}
        data-testid={`related-link-${item.to.replace(/\//g, "")}`}
        className="flex items-center gap-2 px-5 py-3 border border-white/15 text-white/80 text-xs uppercase tracking-[0.15em] hover:border-twp-gold hover:text-twp-gold transition-colors"
      >
        {item.label} <ArrowUpRight size={14} />
      </Link>
    ))}
  </div>
);
